<script setup lang="ts">
import HeaderSimple from '~/components/layouts/HeaderSimple.vue'
</script>

<template>
	<HeaderSimple />
	<slot />
</template>
